import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllSpendGetItemOffersApi,
  deleteSpendGetItemOfferApi,
  toggleSpendGetItemOfferStatusApi,
} from "@/api/spendGetItemOffer";

export const fetchSpendGetItemOffers = createAsyncThunk(
  "spendGetItemOffer/fetchAll",
  async (
    { restaurant_id, page = 1, search = "", status = "", per_page = 10 },
    { rejectWithValue }
  ) => {
    const params = new URLSearchParams();
    params.append("per_page", per_page);
    params.append("page", page);

    if (search) {
      params.append("search_term", search);
    }
    if (status && status !== "0") {
      params.append("status", status);
    }

    const res = await getAllSpendGetItemOffersApi(restaurant_id, params.toString());

    if (res.status === "success") {
      return { ...res.data, search };
    }

    return rejectWithValue(res.message);
  }
);

export const deleteSpendGetItemOfferById = createAsyncThunk(
  "spendGetItemOffer/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteSpendGetItemOfferApi(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

export const toggleSpendGetItemOfferStatusById = createAsyncThunk(
  "spendGetItemOffer/toggleStatus",
  async (id, { rejectWithValue }) => {
    const res = await toggleSpendGetItemOfferStatusApi(id);
    if (res.status === "success") return res.data;
    return rejectWithValue(res.message);
  }
);

const initialState = {
  offers: [],
  singleOffer: null,
  totalPages: 1,

  getLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  toggleStatusLoading: false,

  success: null,
  error: null,
  requestStatus: false,
  search: "",
  status: "",
  perPage: 10,
  currentPage: 1,
};

const spendGetItemOfferSlice = createSlice({
  name: "spendGetItemOffer",
  initialState,
  reducers: {
    clearSpendGetItemOfferMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
    },
    setOfferSearch: (state, action) => {
      state.search = action.payload;
    },
    setStatusFilter: (state, action) => {
      state.status = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchSpendGetItemOffers.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchSpendGetItemOffers.fulfilled, (state, action) => {
        state.getLoading = false;
        state.offers = action.payload.offers || [];
        if (action.payload.pagination) {
          state.totalPages = action.payload.pagination.last_page || 1;
        } else {
          state.totalPages = 1;
        }
      })
      .addCase(fetchSpendGetItemOffers.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteSpendGetItemOfferById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deleteSpendGetItemOfferById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.offers = state.offers.filter(
          (offer) => offer.id !== action.payload
        );
        state.success = "Offer deleted successfully!";
      })
      .addCase(deleteSpendGetItemOfferById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      })

      // Toggle Status
      .addCase(toggleSpendGetItemOfferStatusById.pending, (state) => {
        state.toggleStatusLoading = true;
      })
      .addCase(toggleSpendGetItemOfferStatusById.fulfilled, (state, action) => {
        state.toggleStatusLoading = false;
        const updatedOffer = action.payload;
        if (updatedOffer && updatedOffer.id) {
          state.offers = state.offers.map((offer) =>
            offer.id === updatedOffer.id
              ? { ...offer, status: updatedOffer.status }
              : offer
          );
        }
        state.success = "Status updated successfully!";
      })
      .addCase(toggleSpendGetItemOfferStatusById.rejected, (state, action) => {
        state.toggleStatusLoading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearSpendGetItemOfferMessages,
  setOfferSearch,
  setStatusFilter,
  setPerPage,
  setCurrentPage,
} = spendGetItemOfferSlice.actions;

export default spendGetItemOfferSlice.reducer;
